import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { PanelUserMachineStyle } from '../../../UserMachine/PanelUserMachineStyle';
import { Button, CircularProgress, Grid, Paper, Table, TableCell, TableHead, TableRow, Typography } from '@material-ui/core';
import MigaPan from '../../../../app/orussystem/component/MigaPan';
import { getHistoricoDocumento } from '../../../domain/api/UsersApi';
import { useDispatch } from 'react-redux';
import { BiSearch } from "react-icons/bi";
import theme from '../../../../app/config/themaConfig';
import ListMediciones from './ListMediciones';
import {  AñadirOximetriaModal } from './MedicionOximetria';
import { ROL_USER, USER_ID } from '../../../../app/api-client/constants';
import { crearCapacidad, crearOximetria, getlist, getlisthash } from '../../../domain/api/EvbiApi';
import { Store } from 'react-notifications-component';
import { AñadirCapacidadModal } from './MedicionCapacidad';


export const RegistroDeMediciones = (props) => {
    const classes = PanelUserMachineStyle();
    const dispath = useDispatch();

    const id_user_login = localStorage.getItem(USER_ID)
    const rol_user_login = localStorage.getItem(ROL_USER)

    const [UsersMachine, setUsersMachine] = useState([]);
    const [Basculas, setBasculas] = useState([]);

    const [isLoadUser, setISloaduser] = useState(false);
    const [MensajeError, setMensajeError] = useState(null);

    const [page, setPage] = useState(0)
    const [size] = useState(10)
    const [totalElements, settotalElements] = useState(0)
    const [NuevaOximetria, setNuevaOximetria] = useState(false)
    const [nuevaCapacidad, setNuevaCapacidad] = useState(false)

    const [numeroDocumento, setNumeroDocumento] = useState(0)


    const [busqueda, setBusqueda] = useState("")
    let { id } = useParams();
    const [rowsPerPage] = React.useState(10);

    const idBascula = id === undefined || id === null || id === ":id" || id === "poll" ? 7 : id;

    const reload = async (idBascula, page, rowsPerPage, busqueda) => {

        const usuarios = await getHistoricoDocumento(busqueda);
        try {

            setUsersMachine(usuarios?.respuesta ? usuarios.respuesta : [])

            settotalElements(usuarios.totalElements);
            if (usuarios?.mensaje === "No existe usuario con ese documento") {
                setMensajeError(usuarios.mensaje);
                setISloaduser(false)
            } else {
                setMensajeError(null); // Limpiar mensaje de error si no es el caso
                setISloaduser(false)
            }

        } catch (err) {
            console.log("Este es el error", err)
        }
    }

    const filtrar = () => {
        reload(idBascula, 0, rowsPerPage, busqueda);
        setISloaduser(true)
    };


    const buscador = (e) => {
        setBusqueda(e.target.value, "esta es la busqueda")

    }
    const consultaBasculas = async () => {

        let basculas = [];

        if (rol_user_login === 'ROLE_ADMIN') {
            basculas = await getlist(dispath, "", 0, 100);
        } else {
            basculas = await getlisthash(dispath, id_user_login, "", 0, 100);
        }

        try {
         
            if (basculas.error !== "Internal Server Error") {
                setBasculas(basculas.content)
            } else {

                setBasculas([])
                
            }

        } catch (error) {

        }

    }
    const handledAlert = (title, message, type) => {
        Store.addNotification({
            title: title,
            message: message,
            type: type,
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
                duration: 5000,
                onScreen: true,
            },
        });



    };
    const createOximetria = async (request) => {
        const respuesta = await crearOximetria(dispath, request);

        try {
            if (respuesta.codigo === "0000") {
                handledAlert("Añadido Exitosamente!", `Oximetria añadida `, "success");
                filtrar()
                setNumeroDocumento('')
            } else {

                setBasculas([])
                handledAlert("Alerta", "No se pudo añadir la oximetria", "warning")
            }

        } catch (error) {

        }

    }
    const createCapacidad = async (request) => {
        const respuesta = await crearCapacidad(dispath, request);

        try {
            if (respuesta.codigoRespuesta === "0000") {
                handledAlert("Añadido Exitosamente!", `Espirometria añadida `, "success");
                filtrar()
                setNumeroDocumento('')
            } else {

                setBasculas([])
                handledAlert("Alerta", "No se pudo añadir la Espirometria   ", "warning")
            }

        } catch (error) {

        }

    }


    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            filtrar();
        }
    };
    const primaryColor = theme.palette.primary.main;
    const handleAñadirOximetria = (documento) => {
        consultaBasculas()
        setNuevaOximetria(true)
        setNumeroDocumento(documento)
    };
    const handleAñadirCapacidad = (documento) => {
        consultaBasculas()
        setNuevaCapacidad(true)
        setNumeroDocumento(documento)
    };
    const handleClose = () => {
        setNuevaOximetria(false)
        setNuevaCapacidad(false)
    };
    return (
        <>
            <Grid item xs={12} >
                <br></br>
                <br></br>
                <MigaPan
                    namePage="Registro de mediciones"
                    to="/"
                    namePage2="Datos"
                    to2="/Datos"

                >
                    Home
                </MigaPan>
            </Grid>
            <Paper className={classes.paper} style={{ width: "100%", borderRadius: "15px" }} >
                <Grid item xs={12}>
                    <Grid container >

                        <Grid item xs={6} className={classes.searchContainer} style={{ marginLeft: '15%' }} >
                            <div className={classes.searchInputContainer}>
                                <input
                                    id="descripcion"
                                    type="buscador"
                                    name="descripcion"
                                    onChange={buscador}
                                    value={busqueda}
                                    onKeyPress={handleKeyPress}
                                    className={classes.searchInput}
                                    placeholder="Buscar por documento"
                                    style={{
                                        border: `1px solid ${theme.palette.primary.main}`,
                                        borderRadius: '20px 0px 0px 20px',
                                        padding: '4px 8px',
                                        fontSize: 'inherit',
                                        outline: 'none',
                                        flex: 1,
                                    }}
                                />
                            </div>
                            <Button onClick={filtrar} className={classes.searchButton} style={{ backgroundColor: theme.palette.primary.main }}>
                                <BiSearch />
                            </Button>
                        </Grid>
                        {isLoadUser ? (

                            <CircularProgress style={{ marginLeft: '50%' }} />

                        ) : UsersMachine.length !== 0 ? (
                            <>
                                <Grid item xs={12}>
                                    <Table>
                                        <TableHead color='primary'style={{width:'110%'}}>
                                            <TableRow color='primary'>
                                                <TableCell  style={{ paddingLeft: '0%', width: '9%', color: primaryColor,wordWrap: 'break-word',fontWeight:'bolder' }}>Identificacion</TableCell>
                                                <TableCell style={{ paddingLeft: '3%', width: '12%', color: primaryColor,wordWrap: 'break-word',fontWeight:'bolder' }}>Nombre</TableCell>
                                                <TableCell  style={{ paddingLeft: '0%', width: '7%', color: primaryColor,wordWrap: 'break-word',fontWeight:'bolder'  }}>Género</TableCell>
                                                <TableCell  style={{ paddingLeft: '0%', width: '7%', color: primaryColor,wordWrap: 'break-word',fontWeight:'bolder' }}>Imc</TableCell>
                                                <TableCell  style={{ paddingLeft: '0%', width: '7%', color: primaryColor,wordWrap: 'break-word',fontWeight:'bolder'  }}>Porcentaje de Grasa</TableCell>
                                                <TableCell style={{ paddingLeft: '0%', width: '7%', color: primaryColor,wordWrap: 'break-word',fontWeight:'bolder'  }}>Peso</TableCell>
                                                <TableCell  style={{ paddingLeft: '0%', width: '7%', color: primaryColor,wordWrap: 'break-word',fontWeight:'bolder'  }}>Altura</TableCell>
                                                <TableCell  style={{ paddingLeft: '0%', width: '7%', color: primaryColor,wordWrap: 'break-word',fontWeight:'bolder'  }}>Oximetria</TableCell>
                                                <TableCell  style={{ paddingLeft: '0%', width: '7%', color: primaryColor,wordWrap: 'break-word',fontWeight:'bolder'  }}>Presión Arterial (mmHg) </TableCell>
                                                <TableCell  style={{ paddingLeft: '0%', width: '7%', color: primaryColor,wordWrap: 'break-word',fontWeight:'bolder'  }}>Flujo espiratorio max. </TableCell>
                                                <TableCell style={{ paddingLeft: '0%', width: '7%', color: primaryColor,wordWrap: 'break-word',fontWeight:'bolder'  }}>Porcentaje capacidad pulmonar</TableCell>
                                                <TableCell  style={{ paddingLeft: '0%', width: '7%', color: primaryColor,wordWrap: 'break-word',fontWeight:'bolder'  }}>Fecha Última Medicion</TableCell>
                                                <TableCell  style={{ paddingLeft: '0%', width: '7%', color: primaryColor,wordWrap: 'break-word',fontWeight:'bolder'  }}>Añadir mediciones</TableCell>
                                            </TableRow>
                                        </TableHead>
                                    </Table>
                                </Grid>
                                <Grid item xs={12}>
                                    <ListMediciones
                                        rows={UsersMachine}
                                        isLoadUser={isLoadUser}
                                        page={page}
                                        size={size}
                                        totalElement={totalElements}
                                        setPage={setPage}
                                        idBasula={idBascula}
                                        primaryColor={primaryColor}
                                        busqueda={busqueda}
                                        handleAñadirOximetria={handleAñadirOximetria}
                                        handleAñadirCapacidad={handleAñadirCapacidad}


                                    />
                                </Grid>
                            </>
                        ) : MensajeError ? (
                            <Grid item xs={12}>
                                <Paper className={classes.card}>
                                    <Typography variant="body1" style={{ padding: '1%' }}>No se encuentran resultados para este documento, es necesario pasar por una estación de medición para registrarse</Typography>
                                </Paper>
                            </Grid>
                        ) : null}
                    </Grid>

                </Grid>
                {MensajeError === null && isLoadUser === false && UsersMachine.length === 0 &&(
                    <Grid item xs={12}>
                        <Typography variant="body1" style={{ padding: '1%', textAlign: 'center' }}>Ingresa el documento del usuario para buscarlo en el sistema</Typography>
                    </Grid>
                )}
            </Paper>

            {NuevaOximetria && <AñadirOximetriaModal numeroDocumento={numeroDocumento} Basculas={Basculas} handleClose={handleClose} open={NuevaOximetria} createOximetria={createOximetria} />}
            {nuevaCapacidad && <AñadirCapacidadModal numeroDocumento={numeroDocumento} Basculas={Basculas} handleClose={handleClose} open={nuevaCapacidad} createCapacidad={createCapacidad} />}

        </>
    );

}    